export default __webpack_public_path__ + "logo-capital-fr-horizontal-a515bb9882ba80a56de363152a3b2c68.png";